import { useMutation } from "@tanstack/react-query";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

import { changePassword } from "../api/userProfileApi";

export const useChangePassword = () => {
    const { t } = useTranslation();

    return useMutation({
        mutationFn: changePassword,
        onSuccess: () => {
            Swal.fire(
                t("changePassword"),
                t("doneSuccessfully", { a: "o" }),
                "success"
            ).then();
        },
        onError: () => {
            Swal.fire(
                t("errorTitle"),
                t("internalError"),
                "error"
            ).then();
        },
    });
};
